import { TOP_NAV_HEIGHT } from '@zefr/style-guide/dist/ui/TopNav';

// Any page that has the top nav bar is smaller than a full page.
export const pageSize = `calc(100vh - ${TOP_NAV_HEIGHT})`;
